import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    console.log("app switcher connected")
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    console.log("class list", this.panelTarget.classList)
    this.panelTarget.classList.toggle("is-open")

    if (this.panelTarget.classList.contains("is-open")) {
      document.addEventListener("click", this.handleOutsideClick)
    }
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.panelTarget.classList.remove("is-open")
      document.removeEventListener("click", this.handleOutsideClick)
    }
  }
}

